import jwtSessionService from '@app/services/jwtSessionService'

import type { AxiosInstance, AxiosRequestConfig } from 'axios'

const handleAccessToken = async (config: AxiosRequestConfig): Promise<AxiosRequestConfig> => {
  const session = jwtSessionService.getSession()

  if (session) {
    const { token, type } = session

    config.headers = {
      ...config.headers,
      authorization: `${type} ${token}`
    }
  }

  return config
}

const applyAccessToken = (api: AxiosInstance): void => {
  api.interceptors.request.use(handleAccessToken, async error => await Promise.reject(error))
}

export default applyAccessToken
